import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { SystemInstallAnniversaryReportPage } from '../../modules/ComponentsLibrary/Reports/pages/SystemInstallAnniversaryReport';

export const Route = createFileRoute('/reports/system-install-anniversary')({
  component: SystemInstallAnniversaryReportPage,
  validateSearch: z.object({
    startDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .catch(''),
    endDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .catch(''),
  }),
  beforeLoad({ search }) {
    if (!search.startDate || !search.endDate) {
      throw redirect({ to: '/reports' });
    }
  },
});
